export default {
	name: "Theme Name",
	author: "Author",
	authorUri: "Author URI",
	description: "Description",
	url: "Theme URI",
	tags: "Tags",
	version: "Version",
	license: "License",
	licenseUri: "License URI",
	domainPath: "Domain Path",
	textDomain: "Text Domain",
};
